<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    :save-menu-list="[SAVE]"
    :action-save="onSave"
    :create-default-data="createDefaultData"
    max-width="900px"
    @closed="$emit('closed')"
  >
    <template #title-text>
      Редактировать {{ procedure_name }}
    </template>
    <template #default="{ form, viewOnly }">
      <v-row class="mt-2" dense>
        <v-col cols="5">
          <BTextFieldDate
            v-model="form.scan_start_at"
            validate="required"
            label="Начало сбора"
            :readonly="viewOnly"
            clearable
            datetime
            with-buttons
          />
        </v-col>
        <v-col cols="5">
          <BTextFieldDate
            v-model="form.scan_end_at"
            validate="required"
            :readonly="viewOnly"
            :min="form.scan_start_at"
            label="Окончание сбора"
            clearable
            datetime
            with-buttons
          />
        </v-col>
      </v-row>
      <v-row class="mt-2" dense>
          <v-checkbox
              v-model="form.is_scan_incomplete_sets_allowed"
              label="Разрешить сбор неполных комплектов."
              dense
              hide-details
              class="ma-0 pa-0"
              name="reverse_ordering"
          />
      </v-row>
    </template>
  </BModalForm>
</template>

<script>
import BModalForm from '@/components/modals/BModalForm.vue'
import BTextFieldDate from '@/components/forms/BTextFieldDate.vue'
import { ProceduresApiUpdate } from '@/api/resources/Collector/ProceduresApi'

const createDefaultData = ({ scan_start_at, scan_end_at, is_scan_incomplete_sets_allowed }) => ({
  scan_start_at,
  scan_end_at,
  is_scan_incomplete_sets_allowed
})

const SAVE = {
  name: 'save',
  label: 'Сохранить',
}


export default {
  name: 'ProcedureModal',
  components: {
    BModalForm,
    BTextFieldDate,
  },
  inheritAttrs: false,
  props: {
    procedure_name: {
      type: [String],
      required: true,
    },
    procedure_id: {
      type: [String, Number],
      required: true,
    },
    scan_start_at: {
      type: String,
      default: null,
    },
    scan_end_at: {
      type: String,
      default: null,
    },
    is_scan_incomplete_sets_allowed: {
      type: Boolean,
      default: null,
    },
  },
  data: (vm) => ({
    SAVE,
    createDefaultData: () => createDefaultData(vm),
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    async onSave(body) {
      const api = new ProceduresApiUpdate()
      this.isLoading = true
      try {
        const scanStartAt = new Date(body.scan_start_at).toISOString()
        const scanEndAt = new Date(body.scan_end_at).toISOString()
        const isScanIncompleteSetsAllowed = body.is_scan_incomplete_sets_allowed

        await api.updateProcedure(this.procedure_id, {
          scan_start_at: scanStartAt,
          scan_end_at: scanEndAt,
          is_scan_incomplete_sets_allowed: isScanIncompleteSetsAllowed
        })
      } catch (e) {
        this.$notice.errors(e)
      }
    },
  },
}
</script>
